<template>
  <v-card v-if="campaign" class="info-card-container d-flex flex-column px-5 pt-4 pb-6">
    <div class="coupon-info">
      <div class="coupon-description d-flex justify-space-between align-start">
        <div class="d-flex flex-row">
          <div class="coupon-group d-flex flex-column">
            <span class="coupon-title">{{ campaign.title }}</span>
            <span class="subtitle">{{ campaign.description }}</span>
          </div>
        </div>
        <div class="coupon-group d-flex align-center status">
          <mf-icon fill small :color="getStatusColor">fiber_manual_record</mf-icon>
          <span>{{ getStatusLabel }}</span>
        </div>
      </div>
    </div>
    <div class="coupon-info">
      <div class="coupon-description">
        <div class="d-flex flex-row">
          <div class="coupon-group d-flex flex-column">
            <span>Cupom:</span>
            <span class="coupon-name">{{ campaign.code }}</span>
          </div>
          <div class="coupon-group d-flex flex-column">
            <span>Período de validade:</span>
            <span class="subtitle">{{ `${formatDate(campaign.startDate)} - ${formatDate(campaign.expiresAt)}` }}</span>
          </div>
          <div class="coupon-group d-flex flex-column">
            <span>Validade variável do cupom:</span>
            <span class="subtitle">
              {{ `${campaign.variableValidity ? 'Sim' : 'Não'}` }}
              {{
                campaign.variableValidity
                  ? `- ${campaign.daysToUseBenefitAfterRegistration} ${campaign.daysToUseBenefitAfterRegistration !== 1 ? 'dias' : 'dia'}`
                  : ''
              }}
            </span>
          </div>
          <div class="coupon-group d-flex flex-column">
            <span>Modelo de distribuição:</span>
            <span class="subtitle">
              {{ `${campaign.segments ? 'Com segmento' : 'Com código'}` }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="coupon-chip-lists d-flex flex-column">
      <chip-list title="Lojas participantes:" :items="units" />
      <div v-if="campaign.productsEnabled" class="line" />
      <chip-list v-if="campaign.productsEnabled" title="Produtos vigentes:" :items="products" />
    </div>
  </v-card>
</template>

<script>
import ChipList from '@/components/ChipList.vue'
import { getUnits } from '@/config/helpers.js'
import { DateTime } from 'luxon'
import { couponDiscount } from '../../../mixins/coupon-discount'

export default {
  name: 'CouponCampaignResultsInfoCard',
  components: {
    ChipList,
  },
  mixins: [couponDiscount],
  data: () => ({
    benefitCampaign: null,
    statusOptions: {
      FINISHED: {
        label: 'Concluída',
        color: '#0079F2',
      },
      ACTIVE: {
        label: 'Ativa',
        color: '#0A8533',
      },
      DRAFT: {
        label: 'Rascunho',
        color: '#bfbfbf',
      },
    },
  }),
  computed: {
    getStatusColor() {
      return this.statusOptions[this.campaign.status].color
    },
    getStatusLabel() {
      return this.statusOptions[this.campaign.status].label
    },
    units() {
      return this.campaign.unitsInfo.map((unit) => unit.name)
    },
    products() {
      const campaignProducts = this.campaign.products.map((product) => product.name)
      let groupProducts = []
      this.campaign.productsGroups &&
        this.campaign.productsGroups.map((group) => {
          group.products.map((product) => groupProducts.push(product.name))
        })
      return campaignProducts.concat(groupProducts)
    },
    campaign: {
      get() {
        return this.benefitCampaign
      },
      set(value) {
        this.benefitCampaign = value
      },
    },
  },
  watch: {},
  mounted() {
    this.campaign = this.benefit
  },
  methods: {
    getUnits,
    formatDate(date) {
      return DateTime.fromFormat(date.substring(0, 10), 'yyyy-MM-dd').toFormat('dd/MM/yyyy')
    },
  },
}
</script>

<style lang="scss" scoped>
.info-card-container {
  .coupon-chip-lists {
    gap: 28px;
    .line {
      background: #c3c8cd;
      height: 1px;
    }
  }
  gap: 56px;
  .coupon-info {
    .coupon-description {
      > * {
        gap: 80px;
      }
      .status {
        gap: 4px;
        span {
          color: $cinza-0;
        }
      }
      .coupon-group {
        gap: 8px;
        :first-child {
          color: $cinza-d10;
          font-weight: 700;
          line-height: 120%;
          font-size: 18px;
        }
        .coupon-title {
          font-size: 22px;
        }
        .coupon-name {
          color: $marca-0-l10;
          font-size: 16px;
        }
      }
      .subtitle {
        font-size: 16px;
        color: $cinza-0;
        font-weight: 400;
        line-height: 120%; /* 19.2px */
        letter-spacing: 0.4px;
      }
    }
  }
}
</style>
